// extracted by mini-css-extract-plugin
module.exports = {"ribbon":"CookieConsentRibbon_ribbon__q3JDf","closeButton":"CookieConsentRibbon_closeButton__6vDJw"};